import { Link, NavLink } from "react-router-dom";

const Temples = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-left"> 
                मंदिर
            </h1>
            <div className="h-0.5 w-full bg-orange-500 mb-6"></div>

            <p className="text-gray-700 mb-4 text-left">
                ग्रामपंचायत चांडोली खुर्द,ता.आंबेगाव,जि .पुणे या ठिकणी श्री.काळभैरवनाथ महाराज गावचे ग्रामदैवत असून सदर  मंदिराचा जीर्णोद्धार २०१५ साली सहकार्याने करण्यात आला आहे. मंदिराची उंची ८१ फुट इतकी असून सभामंडप ४२*१०० लांबी रुंदीचा आहे. भैरवनाथ देवस्थान ट्रस्ट (रजी.A-2760/पुणे ) स्थापन करण्यात आले असून ट्रस्टमध्ये हनुमान मंदिर,कळमजाई मंदिर ,मुक्ताई मंदिर यांचा समावेश करण्यात आला असून काळभैरवनाथ मंदिरामध्ये ८ दिवस अखंड हरीनाम सप्ताह व इतर धार्मिक कार्यक्रम केले जातात. 
            </p>

        </div>
    );
}


export default Temples;